import { Record } from "../../../../src/fable_modules/fable-library.3.7.18/Types.js";
import { record_type, string_type } from "../../../../src/fable_modules/fable-library.3.7.18/Reflection.js";
import { MuiHelpers_createElement } from "../../../../../src/Feliz.MaterialUI/./Mui.fs.js";
import { Typography } from "@mui/material";
import { HookImports_useMediaQuery } from "../../../../../src/Feliz.MaterialUI/./Hooks.fs.js";
import { singleton } from "../../../../src/fable_modules/fable-library.3.7.18/List.js";
import { createElement } from "react";
import { Interop_reactApi } from "../../../../src/fable_modules/Feliz.1.68.0/./Interop.fs.js";

class Props extends Record {
    constructor(key) {
        super();
        this.key = key;
    }
}

function Props$reflection() {
    return record_type("Samples.Usage.Hooks.UseMediaQuery.Props", [], Props, () => [["key", string_type]]);
}

export function UseMediaQuerySample(useMediaQuerySampleInputProps) {
    const sampleKey = useMediaQuerySampleInputProps.sampleKey;
    const children = singleton(MuiHelpers_createElement(Typography, [["children", "System dark mode is currently " + (HookImports_useMediaQuery("(prefers-color-scheme: dark)") ? "enabled" : "disabled")]]));
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

